import { Checkbox, Tooltip } from '@mui/material';
import _ from 'lodash';
import React, { } from 'react';
import { useSelector } from 'react-redux';
import EmailEditorButton from '../../../EmailEditorModal/EmailEditorButton';
import { SupportSheetSelector } from '../../reducers/SupportSheetReducer';
import SupportSheetHelpText from '../SupportSheetHelpText/SupportSheetHelpText';
import './SupportSheetCustomCheckbox.scss';
import { CheckList } from '../../models/SupportSheetModel';
import Utility from '../../../../app/utility';

interface CustomCheckBoxProp {

    checked: boolean,
    currentCheckedValue: string,
    helpText?: string,
    htmlBeforeText?: JSX.Element,
    checkboxText: string,
    className?: string,
    showSendEmail: boolean,
    helpTextTitle?: string,
    hideHelpText?: boolean,
    disable?: boolean,
    ignoreValidation?: boolean,
    onChange?: (checked: boolean) => void,
    onClick?: () => void,
    onEmailClick?: () => void,
}

const SupportSheetCustomCheckbox: React.FunctionComponent<CustomCheckBoxProp> = (props) => {
    const supportSheetData = useSelector(SupportSheetSelector);

    const getValidationClassName = () => {
        return supportSheetData.enableValidation && !props.disable && !props.checked && !props.ignoreValidation ? "support-sheet-red-text-error" : "";
    }

    const getCheckDate = () => {
        let checkList = supportSheetData.model.checkLists ? JSON.parse(supportSheetData.model.checkLists) as CheckList :
            {
                checkListItems: [],
                history: []
            } as CheckList;

        let index = _.findIndex(checkList.history, (item) => {
            return item.name + "." === props.currentCheckedValue;
        });

        return index === -1 ? "Haven't completed" : Utility.DateFormat.formatDDMMMYYhhssString(checkList.history[index].date);
    }

    return (
        <div className={
            props.className ? (props.className + " " + getValidationClassName()) : getValidationClassName()
        }>
            <Tooltip title={getCheckDate()} placement="left-start">
                <Checkbox
                    checked={props.checked}
                    disabled={props.disable}
                    onChange={(event) => {
                        if (props.onChange) {
                            props.onChange(event.target.checked)
                        }
                    }}
                    onClick={(event) => {
                        if (props.onClick) {
                            props.onClick()
                        }
                    }}
                />
            </Tooltip>
            <span className='checkbox-email-placeholder'>
                {
                    props.showSendEmail &&
                    <EmailEditorButton
                        disable={props.disable}
                        onClick={() => {
                            if (props.onEmailClick) {
                                props.onEmailClick();
                            }
                        }}
                    ></EmailEditorButton>
                }
            </span>

            {
                !props.hideHelpText &&
                <SupportSheetHelpText
                    title={props.helpTextTitle ? props.helpTextTitle : props.checkboxText}
                    helpText={props.helpText ? props.helpText : ""}
                >
                </SupportSheetHelpText>
            }
            {
                props.htmlBeforeText
            }
            <span
                onClick={() => {
                    if (props.onChange && !props.disable) {
                        props.onChange(!props.checked)
                    }
                }}
                className={'checkbox-text ' + (props.disable ? "email-disable" : "")}
                dangerouslySetInnerHTML={{ __html: props.checkboxText }}
            >
            </span>
        </div>
    )
};

export default SupportSheetCustomCheckbox;